import { Box, Stack } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import React from 'react'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'
import { CPT } from 'types/types/Types'

interface Props {
  item: any
}

export default function CPTModifierItem({ item }: Props) {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1}
      borderRadius="10px"
      border={`1px solid ${colors.itemBorder}`}
    >
      <Stack flex={1} direction={'row'}>
        <Box width={50} display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <CustomText text={item.id} color={colors.primary} />
        </Box>
        <Box ml={0.75}>
          <CustomText text={`${item.percentage}%`} color={colors.black} fontWeight={600}/>
          <CustomText text={item.description} color={colors.black} />
        </Box>
      </Stack>
    </Box>
  )
}
